/*
 * @Author: daiqi@sogou-inc.com
 * @Date: 2021-12-31 14:09:54
 * @Description: common变量
 */

import * as types from '@types';

export default config => ({
  namespaced: true,
  state: () => ({
    $config: config,
    loadingFinished: true,
  }),
  mutations: {
    [types.UPDATE_LOADING_FINISHED](state, bool) {
      state.loadingFinished = bool;
    },
  },
});
